import { render, staticRenderFns } from "./ProductShippingMessages.vue?vue&type=template&id=35e2f642&"
import script from "./ProductShippingMessages.vue?vue&type=script&lang=js&"
export * from "./ProductShippingMessages.vue?vue&type=script&lang=js&"
import style0 from "./ProductShippingMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports